module.exports = __webpack_public_path__ + "static/media/barbitistes_serricauda_005_USD_Tag_mehrere_Ind_APA.9943c2b1.mp3";